export default "__VITE_ASSET__DyF5x3gj__"